import React from 'react';
import { productName } from '../data/content';
import { HeartMark } from './decor/HeartMark';
export function Footer() {
  return <footer className="bg-navy-deep text-white/75" data-id="element-125" data-mp="3ggty8ibanj58">
      <div className="mx-auto flex max-w-content flex-col gap-4 px-5 py-10 text-sm sm:px-8 md:flex-row md:items-center md:justify-between" data-id="element-126" data-mp="32o4d0g3lai96">
        <p className="flex items-center gap-2 font-display text-lg text-white" data-id="element-127" data-mp="36q94b86kf2sn">
          <HeartMark className="h-4 w-4 text-coral" data-id="element-128" data-mp="3ues7xaeo6ree" />
          {productName}
        </p>
        <p className="max-w-xl leading-relaxed md:text-right" data-id="element-129" data-mp="398xsbsbb070">
          Digital product — no physical items are shipped. Printing allowed for personal, church and ministry use. Digital files may not be
          resold, redistributed, shared or uploaded publicly. © 2026
        </p>
      </div>
    </footer>;
}